import { Collapse } from "antd";
import moment from "moment";
import UserList from "./userList";

const { Panel } = Collapse;

const NewUserList = ({ users }) => {
  const grouped = users.reduce((acc, user) => {
    const groupKey = moment(user.activation_month).format("MMMM YYYY");
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(user);
    return acc;
  }, {});

  return (
    <Collapse accordion>
      {Object.entries(grouped).map(([group, groupUsers]) => (
        <Panel header={`${group} (${groupUsers.length})`} key={group}>
          <UserList users={groupUsers} showActivationDate />
        </Panel>
      ))}
    </Collapse>
  );
};

export default NewUserList;
